import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

interface NavbarProps {
  showWorkbookLink?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ showWorkbookLink = true }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <span className="text-lg font-semibold tracking-tight text-slate-800 hover:text-indigo-600 transition-colors">
              Teegal
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <a
              href="/downloads/teegal-setup.exe"
              className="text-sm text-slate-600 hover:text-indigo-600 transition-colors flex items-center gap-1"
            >
              Teegal 工作台
            </a>
            {showWorkbookLink && (
              <a
                href="/#/workbook"
                className="text-sm text-slate-500 hover:text-indigo-600 transition-colors flex items-center gap-1"
              >
                工作之书
              </a>
            )}
            <a
              href="/#/product"
              className="text-sm text-slate-500 hover:text-indigo-600 transition-colors"
            >
              产品介绍
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-slate-500 hover:text-slate-800"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-slate-100 bg-white">
          <div className="px-4 py-3 space-y-2">
            <a
              href="/downloads/teegal-setup.exe"
              className="block text-sm text-slate-500 hover:text-indigo-600 py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Teegal 工作台
            </a>
            {showWorkbookLink && (
              <a
                href="/#/workbook"
                className="block text-sm text-slate-500 hover:text-indigo-600 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                工作之书
              </a>
            )}
            <a
              href="/#/product"
              className="block text-sm text-slate-500 hover:text-indigo-600 py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              产品介绍
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
